import { render, staticRenderFns } from "./Cn-Button.vue?vue&type=template&id=3973c05b&scoped=true&"
import script from "./Cn-Button.vue?vue&type=script&lang=ts&"
export * from "./Cn-Button.vue?vue&type=script&lang=ts&"
import style0 from "./Cn-Button.vue?vue&type=style&index=0&id=3973c05b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3973c05b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
